import { Container, Col, Row } from "react-bootstrap";
import ServicesBio from "./components/servicesBio";
import { useParams } from "react-router-dom";
import ShareModel from "../../components/Sharemodel";
import ShareOption from "../../components/Shareoption";
import { useState } from "react";
import { decodeId } from "../../utils/idObfuscator";
const ServicesOnlineProfile = () => {
  const [showshare, setShowshare] = useState(0);
  const [show, setShow] = useState(0);
  const { id: encodedId } = useParams();
  const id = encodedId ? decodeId(encodedId) : null;
  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const handleClosemodal = () => {
    setShow(0);
  };

  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };
  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        handleClosemodal={handleClosemodal}
        show={show}
        handleShowshare={handleShowshare}
        shareurl={`/services-online/${encodedId}`}
      />
      <Container>
        <Col md={10} lg={12} xl={11} className="screenHeight p-2 mx-auto">
          <Row className="d-flex justify-content-center">
            <Col md={12} lg={12} className="p-4 rounded" style={{backgroundColor:"#fafafa"}}>
              <ServicesBio id={id} shopid={id} setShow={setShow} />
            </Col>
          </Row>
        </Col>
      </Container>
    </>
  );
};
export default ServicesOnlineProfile;
